import React, { useState, useRef, useEffect } from 'react';

const CustomTextArea = ({ value, onChange, hint, textareaLineHeight, maxRows, handleSelection, handleFocus, handleClick, handleKeyDown}) => {
  const [rows, setRows] = useState(1);
  const textareaRef = useRef(null);

  useEffect(() => {

    textareaRef.current.rows = 1;
    const currentRows = Math.floor(textareaRef.current.scrollHeight / textareaLineHeight);

    if (currentRows >= maxRows) {
      textareaRef.current.rows = maxRows;
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    } else {
      textareaRef.current.rows = currentRows;
    }

    setRows(currentRows < maxRows ? currentRows : maxRows);
  }, [value, maxRows, rows, textareaLineHeight]);

  return (
    <textarea
      id='customtextarea'
      ref={textareaRef}
      rows={rows}
      value={value}
      onKeyDown={handleKeyDown}
      onChange={onChange}
      onFocus={handleFocus}
      onClick={handleClick}
      placeholder={hint}
      onSelect={handleSelection && handleSelection}
      style={{ 
        overflowY: rows >= maxRows ? 'auto' : 'hidden',
        borderRadius: rows > 2 ? '10px':'999px'

      }}
    />
  );
};
export default CustomTextArea;